import React, { useState } from 'react';
import { View, Image, Pressable } from 'react-native';
import { Col, Grid } from 'react-native-easy-grid';
import { Link } from 'react-router-dom';
import FileManagerLayout from '../partials/FileManagerLayout';

import styles from '../partials/styles';
import { JText as Text } from '@components/common/JText';
import { TEXT_COLOR_GREEN } from '@assets/style/styleDefault';
import ModalDocument from '../partials/ModalDocument';
import { ROLE_USER } from '@helper/constant';
import { checkPermission } from '@helper/commonFunction';
import { useSelector } from 'react-redux';

const OtherNotificationsData = [
  {
    id: '01-01',
    title: '本人確認コードSMS',
    status: '（本人確認コードSMS_Ver.1.0 ）',
    icon: 'iconTXT.svg',
    iconAdd: 'iconAddTXT.svg',
    type: 'SMSテキストファイル追加',
  },
  {
    id: '01-02',
    title: 'LEVICA ID登録完了通知メール',
    status: '（未設定）',
    icon: 'iconMail.svg',
    iconAdd: 'iconAddMail.svg',
    type: 'メールテンプレート追加',
  },
  {
    id: '01-03',
    title: '残高失効通知メール',
    status: '（未設定）',
    icon: 'iconMail.svg',
    iconAdd: 'iconAddMail.svg',
    type: 'メールテンプレート追加',
  },
  {
    id: '01-04',
    title: 'ギフト新規発行通知メール',
    status: '（未設定）',
    icon: 'iconMail.svg',
    iconAdd: 'iconAddMail.svg',
    type: 'メールテンプレート追加',
  },
  {
    id: '01-05',
    title: 'ポイント新規発行通知メール',
    status: '（未設定）',
    icon: 'iconMail.svg',
    iconAdd: 'iconAddMail.svg',
    type: 'メールテンプレート追加',
  },
  {
    id: '01-06',
    title: '重要なアップデート通知メール',
    status: '（未設定）',
    icon: 'iconMail.svg',
    iconAdd: 'iconAddMail.svg',
    type: 'メールテンプレート追加',
  },
];

const OtherNotifications = () => {
  const [isModalDocument, setModalDocument] = useState(false);
  const [documentSelect, setDocumentSelect] = useState({
    id: '01-06',
    title: '重要なアップデート通知メール',
    status: '（未設定）',
    icon: 'iconMail.svg',
    iconAdd: 'iconAddMail.svg',
    type: 'メールテンプレート追加',
  });
  const userInfo = useSelector((store) => store?.merchantUserInfo);

  const openModal = (item) => {
    setDocumentSelect(item);
    setModalDocument(true);
  };
  return (
    <>
      <FileManagerLayout>
        <View style={styles.container}>
          {OtherNotificationsData.map((item) => (
            <Pressable style={({ hovered }) => [hovered ? styles.itemHovered : styles.px10]} key={item.id}>
              <Grid style={styles.item}>
                <Col size={5} style={styles.firstCol} onPress={() => openModal(item)}>
                  <Image style={styles.iconImgRight} source={require(`@assets/icons/arrowRight.svg`)} />
                  <Image
                    style={item?.icon === 'iconTXT.svg' ? styles.iconImgTxt : styles.iconImgMail}
                    source={require(`../../../assets/icons/${item?.icon}`)}
                  />
                  <Text style={styles.title}>{`${item.id}  ${item.title}`}</Text>
                </Col>
                <Col size={2} style={styles.center}>
                  <Text style={styles.status}>{item.status}</Text>
                </Col>
                <Col size={3} style={styles.center}>
                  <Image
                    style={item?.type === 'SMSテキストファイル追加' ? styles.iconAddTxt : styles.iconAddMail}
                    source={require(`../../../assets/icons/${item?.iconAdd}`)}
                  />
                  <Link
                    to={
                      checkPermission(ROLE_USER.DOCUMENT_MANAGEMENT, userInfo)
                        ? item?.type === 'SMSテキストファイル追加'
                          ? '/file-manager/other-notifications/sms-notifications'
                          : '/file-manager/other-notifications/mail-notifications'
                        : '#'
                    }
                    style={{ color: TEXT_COLOR_GREEN }}
                  >
                    {item.type}
                  </Link>
                </Col>
              </Grid>
            </Pressable>
          ))}
        </View>
      </FileManagerLayout>
      {isModalDocument && (
        <ModalDocument isModal={isModalDocument} setIsModal={setModalDocument} itemSelect={documentSelect} />
      )}
    </>
  );
};

export default OtherNotifications;
